import React from 'react';

import { ReactFCV } from '@types';

import { Image } from '../Image';
import { ImageWrapper, EImageSource } from '../ImageWrapper';

import { StyledImageWrapper } from './styled';

export interface IImageLinkProps {
  width: number;
  height: number;
  url: string;
  sourceKey?: EImageSource;
  linkUrl?: string | null;
  alt?: string;
}

export const ImageLink: ReactFCV<IImageLinkProps> = ({ width, height, url, sourceKey, linkUrl, alt, ...rest }) => (
  <StyledImageWrapper width={width} height={height} href={linkUrl ?? undefined} {...rest}>
    {sourceKey ? <ImageWrapper url={url} sourceKey={sourceKey} alt={alt} /> : <Image url={url} alt={alt} />}
  </StyledImageWrapper>
);
